import React from "react";
import { Grid, Typography, Box, Link } from "@mui/material";
import { EmailOutlined, PeopleOutline } from "@mui/icons-material";
import MUICard from "../../../../components/MUICard/MUICard.component";
import { AppTheme } from "../../../../theme/App.theme";
import "./ContactUs.style.css";

const ContactUs = () => {

  const email = "inquire@hindusrus.org";
  const email_to = `mailto:${email}`;
  const forum_url = "https://groups.google.com/g/hindus-r-us-discussion-forum";

  const openEmail = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      window.location.href = email_to;
    } else {
      window.open(
        `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`,
        "_blank"
      );
    }
  };

  const handleForumClick = () => {
    window.open(forum_url, "_blank");
  };

  const cardStyle = {
    cursor: "pointer",
    borderLeft: `4px solid ${AppTheme.PRIMARY_COLOR}`,
    borderRadius: "8px",
    backgroundColor: AppTheme.DISABLE_BUTTON_COLOR,
    padding: "16px",
    transition: "all 0.3s ease",
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  };

  const iconContainerStyle = {
    width: "48px",
    height: "48px",
    minWidth: "48px",
    minHeight: "48px",
    borderRadius: "50%",
    backgroundColor: AppTheme.PRIMARY_LIGHT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    flexShrink: 0,
  };

  const iconStyle = {
    color: AppTheme.PRIMARY_COLOR,
    fontSize: "24px",
  };

  return (
    <div className="contact-us-page">
      <header className="contact-us-header">
        <div className="contact-us-header-inner">
          <Typography
            component="h1"
            variant="h4"
            className="contact-us-page-title"
          >
            Contact Us
          </Typography>
        </div>
      </header>
      <main className="contact-us-body">
        <Grid container spacing={2}>
          {/* Email Card */}
          <Grid size={{ xs: 12, sm: 6, md: 5, lg: 4 }}>
            <Box
              onClick={openEmail}
              sx={{
                ...cardStyle,
              }}
            >
              <Box sx={iconContainerStyle}>
                <EmailOutlined sx={iconStyle} />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: AppTheme.SUBTITLE_COLOR,
                    fontSize: "14px",
                    marginBottom: 0.5,
                  }}
                >
                  Email us at
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    color: AppTheme.PRIMARY_BLACK,
                    fontSize: "16px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "100%",
                  }}
                >
                  {email}
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Discussion Forum Card */}
          <Grid size={{ xs: 12, sm: 6, md: 5, lg: 4 }}>
            <Box
              onClick={handleForumClick}
              sx={{
                ...cardStyle,
              }}
            >
              <Box sx={iconContainerStyle}>
                <PeopleOutline sx={iconStyle} />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: AppTheme.SUBTITLE_COLOR,
                    fontSize: "14px",
                    marginBottom: 0.5,
                  }}
                >
                  Discussion Forum
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    color: AppTheme.PRIMARY_BLACK,
                    fontSize: "16px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "100%",
                  }}
                >
                  {forum_url}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default ContactUs;